// extracted by mini-css-extract-plugin
module.exports = {"container":"mymessage_container__1KI76","outerContainer":"mymessage_outerContainer__1gqBo"};